export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAIL_FAIL = "GET_USER_DETAIL_FAIL";
export const GET_USER_DETAIL_LOADING = "GET_USER_DETAIL_LOADING";
export const CLEAR_USER_DETAIL = "CLEAR_USER_DETAIL";

